import React from 'react'
import styled from '@emotion/styled'

import { BodyDivFlex } from '../generic/Basics'

export default () => (
  <BodyDivFlex>
    <StyledH1>Please Check Back Shortly</StyledH1>
    <PaddingDiv>We're undergoing site maintenance to give you the best experience possible. We apologize for the temporary inconvenience.</PaddingDiv>
    <PaddingDiv>Please call us if you need immediate assistance at 1-866-545-4059 (Mon.-Sat. 8 a.m.-11 p.m., Sun. 10 a.m. -10 p.m. ET).</PaddingDiv>
  </BodyDivFlex>
)

const PaddingDiv = styled.div`
  padding: 4px 16px;
  text-align: center;
`

const StyledH1 = styled.h1`
  padding: 16px;
  text-align: center;
`
